import clsx from 'clsx';
import Button from 'components/Button';
import {FC} from 'react';
import {c} from 'ttag';

import iconEnterprise from '../assets/images/enterprise_256.png';
import iconIndividual from '../assets/images/individual_256.png';
import iconOrganization from '../assets/images/organization_256.png';
import {planSelect} from '../styles.module.css';
import {BillingScreenName} from '../types';

type TabNavigationProps = {
    activeTab: BillingScreenName;
    onTabChange: (tab: BillingScreenName) => void;
};

const TabNavigation: FC<TabNavigationProps> = ({activeTab, onTabChange}) => (
    <div className={clsx(planSelect, 'grid grid-cols-3')}>
        <Button
            className="flex"
            data-active={activeTab === 'individual'}
            kind="tertiary"
            onClick={() => onTabChange('individual')}
            size="lg"
        >
            <img alt="individual" src={iconIndividual} />
            {c('PlanChange').t`Individual`}
        </Button>
        <Button
            className="flex"
            data-active={activeTab === 'organization'}
            kind="tertiary"
            onClick={() => onTabChange('organization')}
            size="lg"
        >
            <img alt="organization" src={iconOrganization} />
            {c('PlanChange').t`Organization`}
        </Button>
        <Button
            className="flex"
            data-active={activeTab === 'enterprise'}
            kind="tertiary"
            onClick={() => onTabChange('enterprise')}
            size="lg"
        >
            <img alt="enterprise" src={iconEnterprise} />
            {c('PlanChange').t`Enterprise`}
        </Button>
    </div>
);

export default TabNavigation;
